import {
  Button,
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuList, Select, Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaBell } from 'react-icons/fa';
import { BsFillPersonFill, BsGearFill } from 'react-icons/bs';
import { NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { sec } from '../../Services/vulcan';
import { setAccount } from '../../store/account';
import { useGetOrgMeQuery } from '../../Services/orgApi';

const HeaderLinks = () => {
  const navbarIcon = useColorModeValue('white', 'gray.200');
  const menuBg = useColorModeValue('white', 'navy.800');
  const selectBg = useColorModeValue('white', 'navy.800');
  const selectColor = useColorModeValue('gray.800', 'gray.100');
  const user = useSelector((state) => state.account.user);
  const account = useSelector((state) => state.account.account);
  const accounts = useSelector((state) => state.account.accounts || []);
  const dispatch = useDispatch();
  const { data: orgMe } = useGetOrgMeQuery(undefined, { skip: !account });
  const accountLabel = (id) => {
    const row = orgMe?.organizationAccounts?.find((o) => o.accountId === id);
    return row?.name ?? id;
  };

  const onChangeAccount = (e) => {
    const next = e.target.value;
    window.localStorage.setItem('submize_account', next);
    sec.setAccount(next);
    dispatch(setAccount(next));
    window.location.reload();
  };
  return (
    <Flex
      pe={{ sm: '0px', md: '16px' }}
      w={{ sm: '100%', md: 'auto' }}
      alignItems="center"
      flexDirection="row"
    >
      {accounts.length > 1 && (
        <Select
          value={account || ''}
          onChange={onChangeAccount}
          size="sm"
          maxW="220px"
          me="12px"
          color={selectColor}
          bg={selectBg}
        >
          {accounts.map((a) => (
            <option key={a} value={a}>{accountLabel(a)}</option>
          ))}
        </Select>
      )}
      <NavLink>
        <Button
          m="0px"
          px="0px"
          me={{ sm: '2px', md: '16px' }}
          color={navbarIcon}
          variant="no-effects"
          leftIcon={
            <Icon as={BsFillPersonFill} color={navbarIcon} boxSize="22px" m="0px" bg="none" minW="22px" />
          }
        >
          <Text display={{ sm: 'none', md: 'flex' }}>
            {user.name}
            {' '}
            {user.family_name}
          </Text>
        </Button>
      </NavLink>

      <Icon
        as={BsGearFill}
        cursor="pointer"
        ms={{ base: '16px', xl: '0px' }}
        me="16px"
        // onClick={props.onOpen}
        color={navbarIcon}
        w="18px"
        h="18px"
        p="2px"
      />
      <Menu>
        <MenuButton color={navbarIcon} pt="8px">
          <Icon as={FaBell} />
        </MenuButton>
        <MenuList p="16px 8px" bg={menuBg}>
          <Flex flexDirection="column" />
        </MenuList>
      </Menu>
    </Flex>
  );
};

export default HeaderLinks;
